// Validação pura do ficheiro a enviar por WhatsApp. Sem React, sem I/O.
// Devolve uma chave i18n em `erro` quando inválido.

export type TipoMediaEnvio = 'image' | 'document' | 'audio';

export interface ResultadoValidacao {
  ok: boolean;
  tipoMedia: TipoMediaEnvio | null;
  erro: string | null;
}

const MIMES_IMAGEM = new Set(['image/jpeg', 'image/png', 'image/webp']);
const MIMES_DOC = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]);
const LIMITE_IMAGEM = 5 * 1024 * 1024; // 5MB
const LIMITE_DOC = 16 * 1024 * 1024; // 16MB

export function validarFicheiroMedia(
  mime: string,
  tamanhoBytes: number,
): ResultadoValidacao {
  if (MIMES_IMAGEM.has(mime)) {
    if (tamanhoBytes > LIMITE_IMAGEM) {
      return { ok: false, tipoMedia: null, erro: 'panel.media.error.imagemGrande' };
    }
    return { ok: true, tipoMedia: 'image', erro: null };
  }
  if (MIMES_DOC.has(mime)) {
    if (tamanhoBytes > LIMITE_DOC) {
      return { ok: false, tipoMedia: null, erro: 'panel.media.error.docGrande' };
    }
    return { ok: true, tipoMedia: 'document', erro: null };
  }
  return { ok: false, tipoMedia: null, erro: 'panel.media.error.tipoInvalido' };
}
